export const setHeightLayout = (height) => {
    window.parent.postMessage({ clientHeight: document.body.offsetHeight + height }, '*')
}
export const socialShare = (shareType, commentUser, commentContent, commentSetting) => {
    var aUrl = `${commentSetting.domainUrl}${commentSetting.pathName}?cmtid=`;
    switch (shareType) {
        case "fb":
            const openLinkFB = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(aUrl)}&t=&p[images][0]=${commentContent}&quote=${encodeURIComponent(commentUser + ' đã bình Luận : ' + commentContent)}`;
            window.open(openLinkFB, "_blank", "menubar=no,toolbar=no,resizable=no,scrollbars=no,height=450,width=710");
            break;
        case "gg":
            const openLinkGG = "https://plus.google.com/share?url=" + encodeURIComponent(aUrl);
            window.open(openLinkGG, "_blank", "menubar=no,toolbar=no,resizable=no,scrollbars=no,height=450,width=520");
            break;
        case "tw":
            const openLinkTW = 'https://twitter.com/intent/tweet?source=webclient&text="' + commentContent + '..." ' + encodeURIComponent(aUrl);
            window.open(openLinkTW, "_blank", "menubar=no,toolbar=no,resizable=no,scrollbars=no,height=450,width=710");
    }
}
export const timeFormatter = function (_time) {
    var seconds = Math.floor((new Date() - new Date(_time)) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
        return new Date(_time).toLocaleDateString();
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return new Date(_time).toLocaleDateString();
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " ngày trước";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " giờ trước";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " phút trước";
    }
    return Math.floor(seconds) + " giây trước";
}

export const htmlToText = (html) => {
    let tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export const uppercaseFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const createStyles = (selector,content) => {
    const elementTarget = document.querySelector(selector);
    const styleElement = document.createElement('style');
    styleElement.innerHTML = content;
    if(elementTarget.querySelector('style')) elementTarget.removeChild(elementTarget.querySelector('style'));
    elementTarget.appendChild(styleElement);
}

// get cookie
export const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const deleteCookie = (name) => {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

export const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const setCommentActions = (comment_id,payload) => {
    const data = getCookie('vnn-comment-ids');
    if(data.length > 0){
       try {
            const total_actions = JSON.parse(data);
            // console.log(total_actions);
            if(Object.keys(total_actions).length > 0){
                setCookie('vnn-comment-ids',JSON.stringify({
                    ...total_actions,
                    [comment_id]: {
                        type: payload.type,
                        key: payload.key
                    }
                }),7);
            }
       } catch (error) {
            console.log(error);
       }
    }else setCookie('vnn-comment-ids',JSON.stringify({
        [comment_id]: {
            type: payload.type,
            key: payload.key
        }
    }),7);
}
export const removeCommentActions = (comment_id) => {
    const data = getCookie('vnn-comment-ids');
    if(data.length > 0){
       try {
            const total_actions = JSON.parse(data);
            delete total_actions[comment_id]
            if(Object.keys(total_actions).length > 0){
                setCookie('vnn-comment-ids',JSON.stringify(total_actions),7);
            }else {
                deleteCookie('vnn-comment-ids')
            }
       } catch (error) {
            console.log(error);
       }
    }
}
export const getCommentActions = (comment_id) => {
    try {
        const data = getCookie('vnn-comment-ids');
        if(data.length == 0) return null;
        const total_actions = JSON.parse(data);
        if(Object.keys(total_actions).length === 0) return null;
        return total_actions[comment_id];
    } catch (error) {
        return null;
    }
}